import { render, staticRenderFns } from "./DeliveryGroupModifyTemplateForm.vue?vue&type=template&id=74638c2d&scoped=true&"
import script from "./DeliveryGroupModifyTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryGroupModifyTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryGroupModifyTemplateForm.vue?vue&type=style&index=0&id=74638c2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74638c2d",
  null
  
)

export default component.exports